import { render } from "./CodingForm.vue?vue&type=template&id=5d9e8fea"
import script from "./CodingForm.vue?vue&type=script&lang=js"
export * from "./CodingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__